

const Joi = require('joi');
import { HOST } from "common-import/constants";
import { Request } from "common-import/helpers";
// import * as Validator from "./CompanyInfo.Validator.js"

class CompanyInfoAPI {


/*
undefinedPOST http://45.124.86.67:3000/companyInfo/find
Content-Type: application/json

{
    "taxId":"0104585924"
}


*/    


  find = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/companyInfo/find", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*



POST http://45.124.86.67:3000/companyInfo/find
Content-Type: application/json

{
    "name":"houselink"
}


*/    


  find = async (data) => {
    const validator = false; // change this to real variable
    if(validator !== false && !!validator.body) {
      const validateResult = Joi.validate(data, validator.body);
      if(result.error !== null) throw new Error(error);
    }
    let result = await Request.post(HOST + "/companyInfo/find", data);
    if(Request.isValidResponse(result)) return result;
    return Request.handleInvalidResponse(result);
  }


/*

*/    


}
export default new CompanyInfoAPI();



// WEBPACK FOOTER //
// ./src/services/companyInfo/CompanyInfo.API.js